<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editFloor.id ? "Editera" : "Ny" }} våning
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="column">
						<div class="field">
							<label class="label">Våningsnamn</label>
							<div class="control">
								<input
									type="text"
									v-model="floor.name"
									class="input"
									placeholder="Våningsnamn"
								/>
							</div>
						</div>

						<div class="field">
							<label class="label">Beskrivning</label>
							<div class="control">
								<textarea
									v-model="floor.description"
									class="textarea"
									rows="3"
									placeholder="Beskrivning"
								/>
							</div>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>Spara</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		editFloor: Object
	},
	data() {
		return {
			floor: {
				name: '',
				description: ''
			},
			isLoading: false
		};
	},
	computed: {
		disableSave() {
			return this.floor.name == '';
		}
	},
	methods: {
		save() {
			if (!this.isLoading) {
				this.$emit('save', this.floor);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		if (this.editFloor) {
			Object.assign(this.floor, this.editFloor);
		}
	}
};
</script>
